import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPin"><Path d="M14.3669 1.55615L11.011 6.86959L2.35217 9.66277L7.81432 15.1249L2.68932 20.2499L3.74998 21.3106L8.87498 16.1856L14.3371 21.6477L17.1303 12.9889L22.4437 9.63302L14.3669 1.55615Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPin;
